export enum CONFERENCE_TYPE {
    EPI = 1,
    PP = 0,
    DNA = 2,
    CSKONGRES = 3,
}

export enum COMPONENT_TYPE {
    HERO = 0,
    PERSONS = 1,
    PROGRAM = 2,
    INVITATIONS = 3,
    TICKETS = 4,
    ACCOMODATION = 5,
    PARTNERS = 6,
    ARCHIVE = 7,
    REFERENCES = 8,
    ATTACHMENTS = 9,
    VIDEO = 10,
    ABOUT = 11,
    NOTICERECORDING = 12,
    CONTACT = 13,
    ORDERFORMTICKET = 14,
    OPENEVENT = 15,
    PHOTOGALLERY = 16,
    REPORTAGEVIDEO = 17,
    STREAM = 18,
}

export interface IConferenceItem {
    conference: {
        _key: string;
        title: string;
        state: number;
        sub_title: string;
        anotation: string;
        type: number;
        photo: string;
        url_youtube: string;
        slug: string;
        static_gallery: [];
        seo: {
            description: string;
            keywords: string;
            title: string;
        };
        components: {
            type: number;
            inMenu: boolean;
        }[];
        tickets: {
            date: {
                _key: string;
            };
        }[];
        video_invitations: {
            url: string;
        }[];
        archives: {
            conference: {
                name: string;
                url: string;
            }
        }[];
        galleries: {
            _key: string;
        }[];
        references: {
            name: string;
            author: string;
            company: string;
        }[];
        schedule: {
            _key: string;
            part: {
                block_name: string;
                block_subheading: string;
                lecture_name: string;
                from: string;
                to: string;
                block_name2: string;
                nonLecture_name: string;
                description: string;
                lecturers: {
                    _key: string;
                }[];
            }[];
        }[];
        accomodation: {
            blockFirst: string;
            blockSecond: string;
            rooms: {
                name: string;
                type: string;
                price: string;
            }[];
            descriptions: {
                name: string;
            }[];
        };
        showPartnership: boolean;
        redactorTexts: {
            programDescription: string;
            lectorDescription: string;
        };
    };
    dates: {
        date: {
            _key: string;
            conference_stream_days: {
                from: string;
                to: string;
                url: string;
            }[];
        };
        attachments: {
            _key: string;
        }[];
        videos: {
            _key: string;
            url?: string;
        }[];
        accessible: boolean;
    }[];
    lectors: {
        _key: string;
        _from: string;
        name: string;
        surname: string;
        position: string;
        company: string;
        photo: string;
        type: number;
        inHero: boolean;
        titles: {
            before_name: string;
            after_name: string;
        };
    }[];
    partners: {
        _key: string;
        name: string;
        conferencePartnerType: number[];
        isGarant: boolean;
        isPatron: boolean;
        photo: string;
        url: string;
    }[];
    token: string;
}

export interface IPersonItem {
    _key: string;
    name: string;
    surname: string;
    position: string;
    company: string;
    photo: string;
    inHero: boolean;
    annotation: string;
    email: string;
    titles: {
        before_name: string;
        after_name: string;
    };
    links: {
        facebook: string;
        linkedin: string;
        instagram: string;
        twitter: string;
        web: string;
    };
}

export interface IColors {
    colorTitle: string;
    colorLine: string;
    colorLink: string;
    colorLight: string;
    colorLightest: string;
    colorButton: string;
    colorButtonHover: string;
    colorNonLecture: string;
    colorBlockNumber: string;
    colorVideoLink: string;
}

export interface IPartner {
    _key: string;
    name: string;
    conferencePartnerType: number;
    isGarant: boolean;
    isPatron: boolean;
    photo: string;
    url: string;
    description: string;
}

export interface IPartners {
    _key: string;
    name: string;
    conferencePartnerType: number;
    isGarant: boolean;
    isPatron: boolean;
    photo: string;
    url: string;
    description: string;
}

export interface IArchive {
    conference: {
        _key: string;
    };
}

export interface IEventDate {
    date: {
        _key: string;
        from: string;
        to: string;
        state: number;
        visibilityState: number;
    };
}

export interface IDate {
    eventDate: {
        _key: string;
        from: string;
        to: string;
        state: number;
        visibilityState: number;
    };
    modules: {
        type: number;
        price_with_vat: string;
        price: string;
        _key: string;
    }[];
    tags: { title: string; label: boolean; color: string }[];
}

export interface IModule {
    type: number;
}

export interface ITicket {
    name: string;
    description: string;
    date: {
        _key: string;
    };
}
